// Backend 가 발급한 실제 staging prefix 와 상대 경로를 합친 GCS object name 의 byte 경계.
//
// Owns:
// - `<staging_object_key>/<relative_path>` 합성 규칙.
// - declare/PUT 전 배치 전체의 UTF-8 byte 상한 검증.
//
// Does not own:
// - relative_path 정규화와 문자 수 경계(relativePath.ts).
// - signed URL 발급(ticketStore.ts)이나 PUT 실행(putFile.ts).

export const GCS_FLAT_OBJECT_NAME_MAX_BYTES = 1024;

const encoder = new TextEncoder();
const overlongObjectNameMessage =
  "저장소의 경로 길이 한도를 넘는 파일이 있습니다. 폴더 깊이나 파일 이름을 줄인 뒤 다시 업로드해 주세요.";

export function assertStagingObjectNamesWithinLimit(
  stagingObjectKey: string,
  relativePaths: readonly string[],
): void {
  for (const relativePath of relativePaths) {
    const objectName = `${stagingObjectKey}/${relativePath}`;
    if (encoder.encode(objectName).byteLength > GCS_FLAT_OBJECT_NAME_MAX_BYTES) {
      throw new Error(overlongObjectNameMessage);
    }
  }
}
